module.exports = __webpack_public_path__ + "static/media/Polygon.3e22c363.svg";